// demo List
export const SeizerListBase = 'configuration/add-class'
export const seizerList = SeizerListBase + '/list'

// rehabilitation information api
export const rehabilitationInfoListApi = 'rehabilitation-management/rehabilitation-information/list'
export const rehabilitationInfoStatusApi = 'rehabilitation-management/rehabilitation-information/toggle-status'
export const applicantDataByRegApi = 'rehabilitation-management/rehabilitation-information/info-by-registration-number'
export const rehabilitationInfoStoreApi = 'rehabilitation-management/rehabilitation-information/store'
export const rehabilitationInfoUpdateApi = 'rehabilitation-management/rehabilitation-information/update'

// meeting management
export const RehabMeetingManagementListApi = 'rehabilitation-management/meeting-management/list'
export const RehabMeetingManagementStoreApi = 'rehabilitation-management/meeting-management/store'
export const RehabMeetingManagementUpdateApi = 'rehabilitation-management/meeting-management/update'
export const rehabilitatedChildDataApi = 'rehabilitation-management/meeting-management/rehabilitated-child-info'

// disciplinary-action
export const disciplinaryListApi = 'rehabilitation-management/disciplinary-action/list'
export const disciplinaryStoreApi = 'rehabilitation-management/disciplinary-action/store'
export const getDisciplinaryChildren = 'rehabilitation-management/disciplinary-action/get-resident'
export const disciplinaryUpdateApi = 'rehabilitation-management/disciplinary-action/update'

// disciplinary-action
export const parentsMeetingListApi = 'institute-management/parents-meeting/list'
export const parentsMeetingStoreApi = 'institute-management/parents-meeting/store'
// export const getDisciplinaryChildren = 'rehabilitation-management/disciplinary-action/get-resident'
export const parentsMeetingUpdateApi = 'institute-management/parents-meeting/update'

// approval management
export const approvalManagementListApi = 'rehabilitation-management/approval-management/list'
export const approveOrRejectApi = 'rehabilitation-management/approval-management/approve-reject'

// followup management
export const followupManagementListApi = 'rehabilitation-management/followup-management/list'
export const rehabilitationChildApi = 'rehabilitation-management/followup-management/rehabilitation-child'
export const followupManagementStatusApi = 'rehabilitation-management/followup-management/toggle-status'
export const followupManagementStoreApi = 'rehabilitation-management/followup-management/store'
export const followupManagementUpdateApi = 'rehabilitation-management/followup-management/update'

// followup management
export const residentIncidentListApi = 'rehabilitation-management/resident-incident-info/list'
export const residentIncidentStatusApi = 'rehabilitation-management/resident-incident-info/toggle-status'
export const residentIncidentStoreApi = 'rehabilitation-management/resident-incident-info/store'
export const residentIncidentUpdateApi = 'rehabilitation-management/resident-incident-info/update'

export const getDismissedChildren = 'admission/dismissed-children/get-resident'
